<template>
  <div>
    <ModuleHeader>Manifiesto de transportación</ModuleHeader>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <p class="text-subtitle-1">Filtros</p>
            <v-row>
              <v-col md="6" cols="12" class="input">
                <label>Fecha inicial</label>
                <Datepicker
                  @selected="selectDate"
                  :value="input_date.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>
              <v-col md="6" cols="12" class="input">
                <label>Fecha final</label>
                <Datepicker
                  @selected="selectDateFinal"
                  :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>

              <v-col md="12">
                <v-btn @click="getReservas()" color="green" dark>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="12" cols="12">
        <v-row>
          <v-col md="4"> Resultados: </v-col>
          <v-col md="8" class="text-right">
             <v-btn @click="generatePdf(true)" class="mx-1"  color="red" dark>
              <v-icon>mdi-file-pdf</v-icon>
              Manifiesto
            </v-btn>
            <v-btn @click="generatePdf()" class="mx-1"  color="red" dark>
              <v-icon>mdi-file-pdf</v-icon>
              Manifiesto sin costos
            </v-btn>
            <!-- <v-btn color="green" dark
              ><v-icon>mdi-file-excel-box</v-icon>
              <download-excel
                type="xls"
                name="Reporte Transportacion"
                :data="reservas_comp"
                :fields="json_fields"
              >
                Exportar a Excel
              </download-excel>
            </v-btn> -->
          </v-col>
        </v-row>
        <!-- <v-simple-table>
          <thead>
            <tr>
              <th>Hotel</th>
              <th>Pax</th>
              <th>Viaje</th>
              <th>Fecha</th>
              <th>Pick Up</th>
              <th>Tee Time</th>
              <th>Drop off</th>
              <th>Folio Transportacion</th>
              <th>Folio Reserva</th>
              <th>Cliente</th>
              <th>Habitación</th>
              <th>Lobby</th>
              <th>Costo</th>
              <th>Tipo de costo</th>
							<th>Total</th>
              <th>Notas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="reservations.length == 0">
              <td colspan="7">No se encontraron datos</td>
            </tr>
            <template v-for="(res, index) in reservas_comp">
              <tr :key="index">
                <td >{{ res.HotelName }}</td>
								<td >{{ res.Pax }}</td>
								<td >{{ res.TipoViaje }}</td>
                <td >{{ res.Fecha }}</td>
								<td >{{ res.Pickup }}</td>
                <td >{{ res.TeeTime }}</td>
								<td >{{ res.DropOff }}</td>
								<td >{{ res.Confirmation }}</td>
								<td >{{ res.FolioReserva }}</td>
                <td >{{ res.NombreCliente }}</td>
								<td >{{ res.Room }}</td>
								<td >{{ res.Lobby }}</td>
								<td >{{ res.Precio }} {{ res.Moneda }}</td>
								<td >{{ res.TipoCobro }}</td>
								<td >{{ res.Total }} {{ res.Moneda }}</td>
                <td>{{res.Notas}}</td>
              </tr>
            </template>
          </tbody>
        </v-simple-table> -->
        <DataTable class="mt-12" :config="config" :data="reservas_comp" :pageRows="50" @buttonClick="dtButtonClick">
        </DataTable>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Cliente from "../../clases/Cliente.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ManifiestoTransportacion from "../../clases/PdfMakers/ManifiestoTransportacion.js"
import DataTable from "../MainComponents/DataTable.vue";
export default {
  name: "ManifiestoTransportacion.vue",
  components: {
    Datepicker,
    DataTable,
  },
  props: [],
  data() {
    return {
      clienteFilter: "All",
      statusFilter: "All",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      showModal: false,
      MainDepartamento: "",
      formKey: 0,
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      reservations: [],
      status: [],
      img: "/assets/img/iconUser.png",
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: false,
        allowExport: true,
        rawText: "Reporte Transportacion",
        selectConfig: {
          idRowData: "FolioReserva",
        },
        buttons: [],
        fields: [
          { text: "Hotel", value: "HotelName", canBeFiltered: true },
          { text: "Pax", value: "Pax" },
          { text: "Viaje", value: "TipoViaje", canBeFiltered: true },
          { text: "Fecha", value: "Fecha", canBeFiltered: true, dateFilterMode: "all", },
          { text: "Pick Up", value: "Pickup" },
          { text: "Tee Time", value: "TeeTime" },
          { text: "Drop off", value: "DropOff" },
          { text: "Folio Transportacion", value: "Confirmation" },
          { text: "Folio Reserva", value: "FolioReserva", },
          { text: "Cliente", value: "NombreCliente" },
          { text: "Habitación", value: "Room" },
          { text: "Lobby", value: "Lobby" },
          {
            text: "Costo",
            value: "Precio",
            format: (row) => `${row.Precio || 0} ${row.Moneda || ""}`,
          },
          { text: "Tipo de costo", value: "TipoCobro", canBeFiltered: true },
          { text: "Total", value: "Total" },
          { text: "Moneda", value: "Moneda" },
          { text: "Notas", value: "Notas" },
        ],
      },
    };
  },
  methods: {
  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
    
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
    
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
    
        var dataURL = canvas.toDataURL("image/png");
    
        resolve(dataURL);
      };
    
      img.onerror = error => {
        reject(error);
      };
    
      img.src = url;
    })},
    async generatePdf(useCosto) {
      let dataimg= null
      let RS = null
      if(this.$store.getters.getFirebaseApp.tenant == "TNTO"){
        dataimg = await this.getBase64ImageFromURL(require("@/assets/img/logos/TNTO-logo.png"),async (data)=>{
          return data
        })
        RS = "YAKAJUKA SA de CV"+"\n"+
                "MORENO TRANSFER y TOURS S.A de C.V"
      }
      

    

      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        RS: (RS)?RS:"",
        IMG:dataimg?dataimg:null,
        useCosto:useCosto,
        showFirmas: this.$store.getters.getFirebaseApp.tenant != "TNTO",
        TITLE:"Orden de servicios",
        data: this.reservas_comp,
      };
      let docData = ManifiestoTransportacion.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/Horarios"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function(element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      await this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Mayoristas/Coleccion",
        null,
        (snapshot) => {
          this.hoteles = [];
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        }
      );
    },
    successData(data) {
      let duration =
        data.duracion.horas.toString().padStart(2, "0") +
        ":" +
        data.duracion.minutos.toString().padStart(2, "0") +
        ":00";
      let dataHotel = {
        hotelCode: data.codigo,
        hotelName: data.nombre,
        duracionViaje: duration,
      };
      this.saveHotel(dataHotel);
    },

    toggleModal(open) {
      this.showModal = open;
    },
    async getStatus() {
      const database = this.$store.getters.getFirebaseApp.database;
      let data = await database.queryBuilder("RVA/Estatus", [
        database.orderByValue(),
        database.startAt(true),
        database.endAt(true),
      ]);
      let status = data.val();

      this.status = status;
    },
    async getReservas() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filters = [
        firestore.where("RF.FI", ">=", startDate),
        firestore.where("RF.FI", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectedHotel !== "") {
        if (this.selectedHotel !== "Admin" && this.selectedHotel !== "Web") {
          filters.push(
            firestore.where("Accesos", "array-contains", this.selectedHotel)
          );
          filters.push(firestore.where("Creador", "==", "Hotel"));
        } else {
          filters.push(firestore.where("Creador", "==", this.selectedHotel));
        }
      }

      const data = await firestore.queryBuilder("RVA_Reservas", filters);

      this.reservations = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      
      this.showEstad = true;
      this.loadingData = false;

      this.reservations.forEach((element) => {
        if (element.Tarifas) {
          let tarifas = Object.entries(element.Tarifas);
          element.TarifasList = tarifas;
        }
      });
    },
    dtButtonClick(buttonId, idSelected) {},
  },
  computed: {
    compStatus() {
      let arrayStatus = [
        { id: "All", Nombre: "Todos" },
        { id: "Pagado", Nombre: "Pagado" },
        { id: "Parcial", Nombre: "Pagado Parcial" },
      ];
      let status = [];
      if (this.status) {
        status = Object.keys(this.status);
      }
      status.forEach((element, index) => {
        let selected = false;
        let totalRes = 0;
        arrayStatus.push({
          id: element,
          Nombre: element,
          cantidad: totalRes,
          selected: selected,
        });
      });

      return arrayStatus;
    },
    json_fields() {
      let ObjTitle = {
        Hotel: "HotelName",
        Pax: "Pax",
        //Jugadores: "totalAccount",
        Fecha: "Fecha",
        TipoViaje: "TipoViaje",
        PickUp: "Pickup",
        TeeTime: "TeeTime",
        DropOff: "DropOff",
        FolioTransportacion:"Confirmation",
        FolioReserva: "FolioReserva",
        Cliente: "NombreCliente",
        Habitacion:"Room",
        Lobby:"Lobby",
        Costo:"Price.C",
        TipoCobro:"TipoCobro",
        Total: "Total",
        Moneda: "Price.M",
        Notas:"Notas",
      };
      return ObjTitle;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    reservas_comp() {
      let res = [];
      this.reservations.forEach((ele) => {
        let isCanceled = true
        let cuentas = Object.entries(ele.Cuentas)
        cuentas.forEach((cuenta)=>{
          if(cuenta[0] != "Extra"){
            if(cuenta[1].Estatus != "C"){
                isCanceled = false
            }
          } 
        })
        if(ele.Estatus == "Cancelled"){
          isCanceled =  true
        }
        
        if (ele.Mayorista) {
          let index = this.$_.findIndex(this.hoteles, [
            "id",
            ele.Mayorista.Id,
          ]);
          ele.NombreHotel = this.hoteles[index]?.Nombre;
        } else {
          ele.NombreHotel = "Campo de golf";
        }
        if(ele.Transportacion && !isCanceled){
            res.push(
                {
									HotelName:ele.Transportacion.Hotel?.nm,
									Precio:ele.Transportacion.Price?.C,
									Moneda:ele.Transportacion.Price?.M,
									FolioReserva:ele.Folio,
                  Fecha:new moment(ele.RF.FI,"YYYY-MM-DD_HH:mm").format("DD-MM-YYYY"),
                  TeeTime:new moment(ele.RF.FI,"YYYY-MM-DD_HH:mm").format("HH:mm"),
									TipoViaje:(ele.Transportacion.OW)?"One Way":"Round Trip",
									TipoCobro:(ele.Transportacion.TripCharge)?"Por viaje":"Por pasajero",
                  NombreCliente:ele?.Cliente?.Nombre,
                  Notas:ele.Notas,
									Total:(ele.Transportacion.TripCharge)?ele.Transportacion.Price?.C:(ele.Transportacion.Pax*ele.Transportacion.Price?.C),
									...ele.Transportacion
                }
                
            )
        }
        /* if (this.statusFilter == "All") {
          res.push(ele);
        } else {
          if (this.statusFilter == ele.Estatus) {
            res.push(ele);
          }
        }*/
      });

      return res;
    },
    total() {
      let total = 0;
      this.reservations.forEach((ele) => {
        total = total + ele.Totales.USD;
      });
      var formatter = new Intl.NumberFormat("en-US");

      return formatter.format(total);
    },
    golfClub() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "GolfClub"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    extraRider() {
      let golf = 0;
      this.reservations.forEach((ele) => {
        let index = this.$_.findIndex(ele.Addons, ["Id", "ExtraRidder"]);
        if (index >= 0) {
          golf = golf + ele.Addons[index].Cantidad;
        }
      });
      return golf;
    },
    totalPlayers() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.Estatus !== "Cancelled") {
          golf = golf + ele.totalAccount;
        }
      });
      return golf;
    },
    totalPagados() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        if (ele.Estatus === "Pagado") {
          golf = golf + ele.totalPagado;
        }
      });
      return golf;
    },
    totalCancelados() {
      let golf = 0;
      this.reservas_comp.forEach((ele) => {
        golf = golf + ele.totalCancelado;
      });
      return golf;
    },
    comp_hotel() {
      let hotel = [
        { id: "", text: "Todos" },
        { id: "Admin", text: "Administrador" },
        { id: "Web", text: "Sitio Web" },
      ];
      this.hoteles.forEach((ele) => {
        hotel.push({ id: ele.Codigo, text: ele.Nombre });
      });
      return hotel;
    },
    comp_clients() {
      let clientes = [{ value: "All", text: "TODOS" }];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getHorarios();
    this.getHoteles();
    this.getStatus();
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
